import axios from "../utils/axios";

export const getAreaList = () => {
    return axios.get(`/Area/GetList`);
};

export const getMaintenanceType = () => {
    return axios.get(`MaintenanceType/GetList`);
};

export const getAMGetOrderDetailById = (payload) => {
    return axios.get(`/AutonomousMaintenance/GetOrderById?id=${payload}`);
};

export const postAMCreateOrder = (payload) => {
    return axios.post(`/AutonomousMaintenance/CreateOrder`, payload);
};

export const postAMUpdateOrder = (payload) => {
    return axios.put(`/AutonomousMaintenance/UpdateOrder`, payload);
};

export const getAMGetOrderFiles = (payload) => {
    return axios.get(`/AutonomousMaintenance/GetOrderFiles?orderId=${payload}`);
};

export const postAMAddFile = (payload) => {
    return axios.post(`/AutonomousMaintenance/AddFile`, payload);
};

export const getAMOrderList = () => {
    return axios.get(`/AutonomousMaintenance/GetOrderPage`);
};

export const deleteOrderAM = (payload) => {
    return axios.delete(`/AutonomousMaintenance/DeleteOrder?orderId=${payload}`);
};

// export const getAMOrderList = (payload) => { Not Using Any where till now
//     return axios.get(`/AutonomousMaintenance/GetOrderPage?pageNumber=${payload}&pageSize=${payload}`)
// }

export const getActiveCounts = (payload) => {
    return axios.get(`/AutonomousMaintenance/GetActiveCounts`, payload);
};

export const getCheckItemGroupsById = (payload) => {
    return axios.get(`/AutonomousMaintenance/orders/${payload}/CheckItemGroups`);
};

export const deleteAMOrder = (payload) => {
    return axios.delete(`/AutonomousMaintenance/orders?orderId=${payload}`);
};

export const getCheckItemsForTask = (payload) => {
    return axios.get(`/AutonomousMaintenance/tasks/${payload}/CheckItems?PageSize=500`);
};

export const putCheckItemsForTask = (payload) => {
    return axios.put(`/AutonomousMaintenance/tasks/${payload.taskId}/CheckItems`, payload.data);
};
